import { render, staticRenderFns } from "./DoodleMessage.vue?vue&type=template&id=7b39d59a&scoped=true&"
import script from "./DoodleMessage.vue?vue&type=script&lang=js&"
export * from "./DoodleMessage.vue?vue&type=script&lang=js&"
import style0 from "./DoodleMessage.vue?vue&type=style&index=0&id=7b39d59a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b39d59a",
  null
  
)

export default component.exports